// /src/molecules/specialCondition/adddeposit/PaymentSummary.jsx

import React from "react";
import { Paper, Grid, Typography, Divider, Box } from "@mui/material";
import { MaterialCommunityIcons } from "@expo/vector-icons";

const PaymentSummary = ({ data = [] }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        mt: 6,
        border: "1px solid #e0e0e0",
        overflow: "hidden",
      }}
    >
      {/* HEADER */}
      <Grid
        container
        alignItems="center"
        sx={{
          backgroundColor: "#fafafa",
          p: 3,
          borderBottom: "1px solid #eee",
        }}
      >
        <Grid item xs={3}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <MaterialCommunityIcons
              name="identifier"
              size={18}
              color="#666"
            />
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              ID
            </Typography>
          </Box>
        </Grid>

        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <MaterialCommunityIcons
              name="map-marker-outline"
              size={18}
              color="#666"
            />
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              ADDRESS
            </Typography>
          </Box>
        </Grid>

        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        <Grid item xs={2}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <MaterialCommunityIcons
              name="cash-multiple"
              size={18}
              color="#666"
            />
            <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
              AMOUNT TO PAY
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* DATA ROWS */}
      {data.map((item, index) => (
        <Grid
          key={item.id || index}
          container
          alignItems="center"
          sx={{
            p: 2,
            borderBottom: index !== data.length - 1 ? "1px solid #eee" : "none",
          }}
        >
          {/* ID */}
          <Grid item xs={3}>
            <Typography fontWeight={600}>{item.id}</Typography>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* ADDRESS */}
          <Grid item xs={6}>
            <Typography>{item.address}</Typography>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* AMOUNT */}
          <Grid item xs={2}>
            <Typography fontWeight={700}>{item.amount}</Typography>
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};

export default PaymentSummary;
